import { BaseAnalyticsObserver } from './baseAnalyticsObserver';

export class NullAnalyticsObservers extends BaseAnalyticsObserver {
  event(event: string, eventData?: { [key: string]: any }) {
    // do nothing
  }
}
